import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import {
  FlexColumn,
  OverflowAwareText,
} from '~components/Order/ordersDispatchStyledComponents';
import { Ticket } from '~hooks/useTickets/models';
import { TicketExportIndicator } from '~pages/Approvals/ApprovalsComponents/TicketExport';

interface TicketColumnProps {
  ticket: Ticket;
  sx?: SxProps<Theme>;
}

export default function TicketColumn({ ticket, sx }: TicketColumnProps) {
  const ticketNumber = ticket.externalTicketNumber ?? ticket.ticketNumber;

  return (
    <FlexColumn sx={sx}>
      <Box sx={{ alignItems: 'center', display: 'flex', gap: 1, minWidth: 0 }}>
        <OverflowAwareText>{ticketNumber}</OverflowAwareText>
        <TicketExportIndicator ticket={ticket} />
      </Box>
    </FlexColumn>
  );
}
